module.exports = __webpack_public_path__ + "media/kling26-demo.fbf81992.mp4";